import ModulesItem from './modulesItem';

export default ModulesItem;
